import { Loader } from "../Loader";

export const LoadingModalContent = () => {
  return (
    <div class="p-16 tw:text-center">
      <Loader />
    </div>
  );
};
